<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          v-bind="attrs"
          v-on="on"
          :text="text"
          :small="small"
          :disabled="disabled"
          :class="actionClass"
          :color="actionColor">
        {{ actionText }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>

      <v-card-text>
        {{ description }}

        <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
            class="mt-4"
        >
          <v-text-field
              dense
              outlined
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              autocomplete="on"
              required
              v-on:keypress="keyPress"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="submit"
        >
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar
        v-model="snackbar.show"
        timeout="3000"
        :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Ok
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import {handleResponseError} from '@/api/handleError'

export default {
  name: "ResetPasswordModal",
  props: {
    text: Boolean,
    small: Boolean,
    disabled: Boolean,
    actionText: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String
    },
    actionColor: {
      type: String,
      default: 'primary'
    },
    actionClass: String,
    onSuccess: Function
  },
  methods: {
    showNotification: function (message, color) {
      this.snackbar.text = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    keyPress: function (e) {
      if (e.keyCode === 13) {
        e.preventDefault()
        this.submit()
      }
    },
    cancel: function() {
      this.open = false
    },
    submit: async function () {
      this.loading = true
      try {
        await this.$store.dispatch('auth/sendPasswordResetEmail', this.email)
            .then(() => {
              this.loading = false
              this.open = false
              this.onSuccess()
            })
            .catch(e => {
              this.loading = false
              const message = handleResponseError(e)
              this.showNotification(message, 'red darken-2')
            })
      } catch (e) {
        const message = handleResponseError(e)
        this.showNotification(message, 'red darken-2')
      }
    }
  },
  data: () => ({
    snackbar: {
      text: '',
      show: false,
      color: '',
    },
    open: false,
    loading: false,
    formValid: false,
    email: '',
    emailRules: [
      v => !!v || 'E-mail é obrigatório',
      v => /.+@.+\..+/.test(v) || 'E-mail inválido',
    ],
  })
}
</script>